/*
  ef-picker.js — posts the PDP bundle picker's selection to the cart.

  One /cart/add.js containing the pit and, on a fuel tier, the refill. Both lines carry
  _ef_bundle (a uuid shared across the group) and _ef_bundle_name, which is how the cart draws
  them as one bundle.

  IT APPLIES NO DISCOUNT. The saving comes from a Shopify cart-contents rule. This file must
  never compute a price and send it — it sends products and quantities, nothing else.

  Spec: Doc/Ecomm/EcoFuego_Cart_Build_Spec.md 1a
*/
(function () {
  'use strict';

  // Object.assign is ES6; this file targets the same baseline as the rest of the theme.
  function assign(target) {
    for (var i = 1; i < arguments.length; i++) {
      var src = arguments[i] || {};
      for (var k in src) if (Object.prototype.hasOwnProperty.call(src, k)) target[k] = src[k];
    }
    return target;
  }

  function uuid() {
    try {
      if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID();
    } catch (e) {}
    return 'ef-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
  }

  function selectedQty(root) {
    var checked = root.querySelector('.ef-picker__radio:checked');
    return checked ? parseInt(checked.value, 10) || 0 : 0;
  }

  function tierName(root) {
    var checked = root.querySelector('.ef-picker__radio:checked');
    if (!checked) return '';
    var label = checked.closest('.ef-picker__tier');
    var name = label && label.querySelector('.ef-picker__name');
    return name ? name.textContent.trim() : '';
  }

  function showError(root, msg) {
    var el = root.querySelector('[data-ef-picker-err]');
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
  }

  function clearError(root) {
    var el = root.querySelector('[data-ef-picker-err]');
    if (el) el.hidden = true;
  }

  function openCart() {
    // Prefer the theme's own drawer. Fall back to the cart page rather than leaving the
    // shopper on a page that looks like nothing happened.
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      try {
        drawer.open();
        return true;
      } catch (e) {}
    }
    document.dispatchEvent(new CustomEvent('ef:cart:updated'));
    return false;
  }

  function wire(root) {
    var btn = root.querySelector('[data-ef-picker-add]');
    if (!btn) return;

    btn.addEventListener('click', function () {
      clearError(root);

      var pit = root.getAttribute('data-pit-variant');
      var fuel = root.getAttribute('data-fuel-variant');
      var qty = selectedQty(root);
      if (!pit) return;

      var items = [];

      if (qty > 0 && fuel) {
        var group = uuid();
        var name = tierName(root);
        /*
          _ef_unit_qty is how many of THIS line make ONE bundle. The cart needs it to offer a
          single stepper for the group: bundle quantity 2 means two pits and four refills, and
          without the ratio the cart would have to guess it from whatever is currently in the
          basket — which breaks the moment somebody edits a line by hand.
        */
        var props = { _ef_bundle: group, _ef_bundle_name: name };
        /*
          _ef_bundle_pos fixes the reading order of the group. Shopify orders cart lines by when
          a variant first entered the basket, NOT by the order they were posted — so a shopper
          who already had refills in the cart got "2 x Wax Refills + 1 x El Campo Fire Pit",
          which reads backwards for a bundle named after its fire pit. Observed live 2026-09-22.
        */
        items.push({ id: Number(pit), quantity: 1, properties: assign({}, props, { _ef_unit_qty: '1', _ef_bundle_pos: '0' }) });
        items.push({ id: Number(fuel), quantity: qty, properties: assign({}, props, { _ef_unit_qty: String(qty), _ef_bundle_pos: '1' }) });
      } else {
        // A single line is not a bundle, so it carries no grouping property.
        items.push({ id: Number(pit), quantity: 1 });
      }

      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || e.message || 'Could not add to cart'); });
          return r.json();
        })
        .then(function () {
          // Ask the theme to re-render the cart, then open it.
          return fetch('/?sections=cart-drawer,cart-icon-bubble')
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (sections) {
              if (sections) {
                var map = { 'cart-drawer': '#CartDrawer', 'cart-icon-bubble': '#cart-icon-bubble' };
                Object.keys(map).forEach(function (key) {
                  var host = document.querySelector(map[key]);
                  if (!host || !sections[key]) return;
                  var parsed = new DOMParser().parseFromString(sections[key], 'text/html');
                  var fresh = parsed.querySelector(map[key]);
                  if (fresh) host.innerHTML = fresh.innerHTML;
                });
                var cd = document.querySelector('cart-drawer');
                if (cd) cd.classList.remove('is-empty');
              }
              if (!openCart()) window.location.href = '/cart';
            });
        })
        .catch(function (err) {
          showError(root, err && err.message ? err.message : 'Could not add to cart. Please try again.');
        })
        .then(function () {
          btn.disabled = false;
        });
    });
  }

  /*
    Suppress Kaching's bundle bars where OUR picker rendered.

    Measured 2026-09-17: removing 'bundles' from block_order in a market context template does
    NOT stop Shopify rendering the parent's app block. Both widgets appear, ours above theirs,
    offering the same two bundles twice at the same prices — confusing, and a second add-to-cart
    path we do not control.

    THIS IS A STOPGAP AND MUST NOT BECOME THE ANSWER. The real fix is scoping the Kaching deal
    with excludedMarketIds in the app's own dashboard, which is needed regardless: the refill
    ladder is cart-contents keyed and will double-discount US baskets the moment a native ladder
    goes live. Hiding markup does nothing about that.

    Keyed on our picker being present rather than on market, so it is self-correcting: no picker,
    no hiding, and Kaching shows normally. Removing this block is all it takes to undo.
  */
  function hideKachingBars() {
    if (!document.querySelector('[data-ef-picker]')) return;
    var blocks = document.querySelectorAll('.kaching-bundles__block, .kaching-bundles');
    for (var i = 0; i < blocks.length; i++) {
      blocks[i].setAttribute('data-ef-superseded', 'true');
      blocks[i].style.display = 'none';
    }
  }

  /*
    Hide the buy box's own Add to cart while our picker is on the page.

    The theme button adds ONLY the bare product, so with the picker above it a shopper sees two
    add buttons where one ignores the bundle they just chose — and the two were different oranges
    besides. Marks the nearest product form instead of the button, so the quantity selector that
    belongs to it goes too.
  */
  function supersedeThemeForm() {
    if (!document.querySelector('[data-ef-picker]')) return;
    var forms = document.querySelectorAll('form[action$="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      if (forms[i].closest('[data-ef-picker]')) continue; // never our own
      var host = forms[i].closest('.product-form') || forms[i];
      host.setAttribute('data-ef-picker-supersedes-form', 'true');
    }
  }

  function init() {
    var nodes = document.querySelectorAll('[data-ef-picker]');
    for (var i = 0; i < nodes.length; i++) wire(nodes[i]);
    hideKachingBars();
    supersedeThemeForm();
    // Kaching renders asynchronously, so a single pass at init can run before its markup exists.
    var tries = 0;
    var poll = setInterval(function () {
      hideKachingBars();
      supersedeThemeForm();
      if (++tries > 20) clearInterval(poll);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
